export enum AudioControlAction {
    SEEK = "seek",
    PLAYBACK_RATE = "playbackRate",
    VOLUME = "volume",
    SKIP_BACKWARD = "skipBackward",
    SKIP_FORWARD = "skipForward",
    TOGGLE_MUTE = "toggleMute",
}

export interface IAudioSnapshot {
    readonly currentTime: number;
    readonly duration: number | null;
    readonly paused: boolean;
    readonly readyState: number;
    readonly networkState: number;
    readonly seekableRangeCount: number;
    readonly seekableStart: number | null;
    readonly seekableEnd: number | null;
    readonly errorCode: number | null;
    readonly hasSrc: boolean;
}

export interface IAudioControlContext {
    readonly action: AudioControlAction;
    readonly payload: number;
    readonly before: IAudioSnapshot;
    readonly afterSync: IAudioSnapshot;
}

export const AUDIO_CONTROL_CATEGORY = "audio.control";
export const AUDIO_CONTROL_VERIFY_CATEGORY = "audio.control.verify";

export const EPSILON = 0.5;
